export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/routing.worker.51f5a027.worker.js");
}
